import React from 'react'
import * as yup from 'yup'
import { useContext, useEffect, useState } from 'react'
import { useFormik } from 'formik'
import { useApiCall } from '../../../custom-hooks/api-call'
import Swal from 'sweetalert2'
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import { format } from 'date-fns'
import { Alert, Snackbar } from '@mui/material'
import { FormArea, FeildWraper, FormLineBreak, FormHeading1, SelectSearch, FeildError, FormLabel } from '../../../form/form-layout'
import { GlobalContext } from '../../../../context/Context'
import { useNavigate } from 'react-router'
import moment from 'moment'


const AddUpdateJob = ({ Style, data, onClose = () => { }, onChange = () => { }, jobTypes = [], sites = [], branches = [], departments = [] }) => {
    const apiCall = useApiCall();
    let { state } = useContext(GlobalContext);
    const [deptUserList, setDeptUserList] = useState([]);
    const [alertData, setAlertData] = useState({ isShow: false });
    const [heads, setHeads] = useState([])
    const validationSchema = yup.object().shape({
        title: yup.string().required('This Field is Required'),
        position: yup.string().required('This Field is Required'),
        department: yup.string().required('This Field is Required'),
        shortDes: yup.string().required('This Field is Required'),
        fullDes: yup.string().required('This Field is Required'),
        shift: yup.string().required('This Field is Required'),
        jobType: yup.string().required('This Field is Required'),
        site: yup.string().required('This Field is Required'),
        branch: yup.string().required('This Field is Required'),
        noOfPosition: yup.string().required('This Field is Required'),
        education: yup.string().required('This Field is Required'),
        experience: yup.string().required('This Field is Required'),
        reason: yup.string().required('This Field is Required'),
        salary: yup.string().required('This Field is Required'),
        skills: yup.string().required('This Field is Required'),
        priority: yup.string().required('This Field is Required'),
        targetDate: yup.string().required('This Field is Required'),
        reporting_authority: yup.string().when([], {
            is: () => (state?.user?.user_role == 1 || state?.user?.user_role == 2 || state?.user?.user_role == 3), // check your state here
            then: (schema) => schema.required("This Field is Required"),
            otherwise: (schema) => schema.notRequired(),
        })
    });

    const navigate = useNavigate()

    const handleClose = () => {
        setAlertData({ isShow: false })
    }
    const onApplyError = (message) => {
        setAlertData({ isShow: true, type: "error", message: message })
    }
    const formik = useFormik({
        initialValues: {
            title: '',
            position: '',
            department: '',
            shortDes: '',
            fullDes: '',
            shift: '',
            jobType: '',
            site: '',
            branch: '',
            noOfPosition: '',
            education: '',
            experience: '',
            reason: '',
            salary: '',
            skills: '',
            priority: 'Medium',
            targetDate: '',
            reporting_authority: ''
        },
        enableReinitialize: true,
        validationSchema,
        onSubmit: async (values) => {

            let apiData = {
                "jobtitle": values?.title,
                "position": values?.position,
                "shortdescription": values?.shortDes,
                "job_description": values?.fullDes,
                "department": values?.department,
                "job_type": values?.jobType,
                "job_site": values?.site,
                "job_site_branch": values?.branch,
                "timeshifts": values?.shift,
                "no_of_people": values?.noOfPosition,
                "education": values?.education,
                "experience": values?.experience,
                "hiringreason": values?.reason,
                "due_date": moment(values?.targetDate).format("YYYY-MM-DD"),
                "salaryrange": values?.salary,
                "skills": values?.skills,
                "reporting_manager": (state?.user?.user_role == 1 || state?.user?.user_role == 2 || state?.user?.user_role == 3) ? values?.reporting_authority : state?.user?.employee_id
            }
            
            try {
                let apiRes = await apiCall({url: "store-job-requisition", method: "post", data: apiData});
                Swal.fire(
                    'Submitted!',
                    apiRes?.message,
                    'success'
                )
                onClose();
                navigate("/job/my-space/all-jobs")
                
            } catch (error) {
                onApplyError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
                console.warn("Error : ", error)
            }
        }
    });
    const popupClosed = () => {
        onClose();
    }
    const getDeptUsersList = async (deptId) => {
        try {
            let res = await apiCall({ method: 'get', url: `get-dept-users-list/${deptId}` });
            setDeptUserList(res?.deptUsersList);
        } catch (error) {
            console.warn("Error : ", error)
        }
    }

    useEffect(() => {
        let id = data?.employee_id;

        if (id) {
            getDeptUsersList(data?.department);
        }
    }, [data?.employee_id]);
    
    return (
        <>
            <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
                <div className={Style.modal_body}>
                    <FormArea>
                        {/* <FormHeading1>User Account Information</FormHeading1> */}
                        <FeildWraper>
                            <FormLabel required>Title</FormLabel>
                            <input
                                type={'text'}
                                name={'title'}
                                onChange={formik.handleChange}
                                value={formik.values.title}
                                placeholder='Title'
                            />
                            {formik.touched.title && formik.errors.title && (
                                <FeildError>{formik.errors.title}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Position</FormLabel>
                            <input
                                type={'text'}
                                name={'position'}
                                onChange={formik.handleChange}
                                value={formik.values.position}
                                placeholder='Position'
                            />
                            {formik.touched.position && formik.errors.position && (
                                <FeildError>{formik.errors.position}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Short Description</FormLabel>
                            <textarea
                                name="shortDes"
                                value={formik.values.shortDes}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                placeholder="Short Description"
                            />
                            {formik.touched.shortDes && formik.errors.shortDes && (
                                <FeildError>{formik.errors.shortDes}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Full Description</FormLabel>
                            <textarea
                                name="fullDes"
                                value={formik.values.fullDes}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                placeholder="Full Description"
                            />
                            {formik.touched.fullDes && formik.errors.fullDes && (
                                <FeildError>{formik.errors.fullDes}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Department</FormLabel>
                            <SelectSearch
                                name="department"
                                placeholder='- Select Department -'
                                onChange={(val) => {
                                    formik.setFieldValue("department", val);
                                    const departHead = departments?.find((eachDepart) => eachDepart?.department_id == val)
                                    setHeads(departHead?.heads)
                                    formik.setFieldValue("reporting_authority", ""); // reset RA
                                }}
                                value={formik.values.department}
                                options={departments?.map((el) => ({
                                    label: el.department_name,
                                    value: el.department_id,
                                }))}
                            />
                            {formik.touched.department && formik.errors.department && (
                                <FeildError>{formik.errors.department}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Shift</FormLabel>
                            <SelectSearch
                                name="shift"
                                placeholder='- Select Shift -'
                                onChange={(val) => { formik.setFieldValue("shift", val); }}
                                value={formik.values.shift}
                                menuPlacement='top'
                                options={Object.entries(state?.getDropdowns?.shiftList).map(([key, val]) => ({
                                    label: val,
                                    value: key,
                                }))}
                            />
                            {formik.touched.shift && formik.errors.shift && (
                                <FeildError>{formik.errors.shift}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Job Type</FormLabel>
                            <SelectSearch
                                name="jobType"
                                placeholder='- Select Type -'
                                onChange={(val) => { formik.setFieldValue("jobType", val); }}
                                value={formik.values.jobType}
                                menuPlacement='top'
                                options={jobTypes?.map((eachType, i) => ({
                                    label: eachType?.title,
                                    value: eachType?.id,
                                }))}
                            />
                            {formik.touched.jobType && formik.errors.jobType && (
                                <FeildError>{formik.errors.jobType}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Job Site</FormLabel>
                            <SelectSearch
                                name="site"
                                placeholder='- Select Site -'
                                onChange={(val) => { formik.setFieldValue("site", val); }}
                                value={formik.values.site}
                                menuPlacement='top'
                                options={sites.map((eachSite, i) => ({
                                    label: eachSite?.name,
                                    value: eachSite?.id,
                                }))}
                            />
                            {formik.touched.site && formik.errors.site && (
                                <FeildError>{formik.errors.site}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Branch</FormLabel>
                            <SelectSearch
                                name="branch"
                                placeholder='- Select Branch -'
                                onChange={(val) => { formik.setFieldValue("branch", val); }}
                                value={formik.values.branch}
                                menuPlacement='top'
                                options={branches.map((eachBranch) => ({
                                    label: eachBranch?.branch_name,
                                    value: eachBranch?.id,
                                }))}
                            />
                            {formik.touched.branch && formik.errors.branch && (
                                <FeildError>{formik.errors.branch}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Number Of Position</FormLabel>
                            <input
                                type={'number'}
                                name={'noOfPosition'}
                                onChange={formik.handleChange}
                                value={formik.values.noOfPosition}
                                placeholder='No. Of Position'
                            />
                            {formik.touched.noOfPosition && formik.errors.noOfPosition && (
                                <FeildError>{formik.errors.noOfPosition}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Education Level</FormLabel>
                            <input
                                type={'text'}
                                name={'education'}
                                onChange={formik.handleChange}
                                value={formik.values.education}
                                placeholder='Education Level'
                            />
                            {formik.touched.education && formik.errors.education && (
                                <FeildError>{formik.errors.education}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Experience Level</FormLabel>
                            <input
                                type={'text'}
                                name={'experience'}
                                onChange={formik.handleChange}
                                value={formik.values.experience}
                                placeholder='Experience Level'
                            />
                            {formik.touched.experience && formik.errors.experience && (
                                <FeildError>{formik.errors.experience}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Hiring Reason</FormLabel>
                            <input
                                type={'text'}
                                name={'reason'}
                                onChange={formik.handleChange}
                                value={formik.values.reason}
                                placeholder='Hiring Reason'
                            />
                            {formik.touched.reason && formik.errors.reason && (
                                <FeildError>{formik.errors.reason}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Salary Range</FormLabel>
                            <input
                                type={'text'}
                                name={'salary'}
                                onChange={formik.handleChange}
                                value={formik.values.salary}
                                placeholder='Salary Range'
                            />
                            {formik.touched.salary && formik.errors.salary && (
                                <FeildError>{formik.errors.salary}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Skills</FormLabel>
                            <input
                                type={'text'}
                                name={'skills'}
                                onChange={formik.handleChange}
                                value={formik.values.skills}
                                placeholder='Salary Range'
                            />
                            {formik.touched.skills && formik.errors.skills && (
                                <FeildError>{formik.errors.skills}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Priority</FormLabel>
                            <SelectSearch
                                name="priority"
                                placeholder='- Select Priority -'
                                onChange={(val) => { formik.setFieldValue("priority", val); }}
                                value={formik.values.priority}
                                menuPlacement='top'
                                options={[{label: "Low", value: "Low"}, {label: "Medium", value: "Medium"}, {label: "High", value: "High"}]}
                            />
                            {formik.touched.priority && formik.errors.priority && (
                                <FeildError>{formik.errors.priority}</FeildError>
                            )}
                        </FeildWraper>
                        
                        <FeildWraper>
                            <FormLabel required>Target Date</FormLabel>
                            <DatePicker
                                selected={formik.values.targetDate}
                                onChange={(date) => formik.setFieldValue("targetDate", date)}
                                dateFormat="dd-MMMM-yyyy"
                                placeholderText="DD/MM/YYYY"
                                className="form-control"
                            />
                            {formik.touched.targetDate && formik.errors.targetDate && (
                                <FeildError>{formik.errors.targetDate}</FeildError>
                            )}
                        </FeildWraper>

                        {(state?.user?.user_role == 1 || state?.user?.user_role == 2 || state?.user?.user_role == 3) ?
                            <FeildWraper>
                                <FormLabel required>Reporting</FormLabel>
                                <SelectSearch
                                    name="reporting_authority"
                                    placeholder='- Select Reporting -'
                                    onChange={(val) => {
                                        formik.setFieldValue("reporting_authority", val);
                                    }}
                                    value={formik.values.reporting_authority}
                                    options={heads?.map((el) => ({
                                        label: el.employee_name,
                                        value: el.employee_id,
                                    }))}
                                />
                                {formik.touched.reporting_authority && formik.errors.reporting_authority && (
                                    <FeildError>{formik.errors.reporting_authority}</FeildError>
                                )}
                            </FeildWraper>
                            :
                            null
                        }
                    </FormArea>
                </div>

                <div className={Style.modal_foot}>
                    <div className={`${Style.dcmb__cancel} opacity-0 pointer-events-none cursor-default`}>Cancel</div>
                    <button type="submit" className={Style.dcmb__submit}>Submit</button>
                </div>
            </form>

            <Snackbar open={alertData?.isShow} autoHideDuration={3000} onClose={handleClose}>
                <Alert
                    onClose={handleClose}
                    severity={alertData?.type}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {alertData?.message}
                </Alert>
            </Snackbar>
        </>
    )
}

export default AddUpdateJob
